import { isHex, hexToString, u8aToHex } from '@polkadot/util';
import { decodeAddress } from '@polkadot/keyring';
import slugify from 'slugify';

const unwrapURI = (uri) => decodeURIComponent(uri);
const unwrapJSON = (json, throwable = true) => {
  try {
    return JSON.parse(json);
  } catch (error) {
    if (throwable) {
      throw error;
    }
    return void 0;
  }
};
const wrapURI = (uri) => encodeURIComponent(uri);
const wrapJSON = (json) => JSON.stringify(json);
const wrapToString = (object) => wrapURI(wrapJSON(object));

const decodeHex = (hex) => {
  return isHex(hex) ? hexToString(hex) : hex;
};
const addressToHex = (address) => {
  return isHex(address) ? address : accountToPublicKey(address);
};
const accountToPublicKey = (accountId) => {
  return accountId && u8aToHex(decodeAddress(accountId)) || "";
};

const SEP = "_";
const trim = (text) => (text || "").trim();
const trimAll = (text) => (text || "").replace(/\s/g, "");
const toSlug = (text, replacement = SEP, strict) => slugify(text, { replacement, strict });
const upperTrim = (name, shouldSlugify) => {
  const result = trim(name).toUpperCase();
  return shouldSlugify ? toSlug(result, SEP, true) : result;
};
const lowerTrim = (name, shouldSlugify) => {
  const result = trim(name).toLowerCase();
  return shouldSlugify ? toSlug(result, SEP, true) : result;
};
const toUpperCase = (name) => name.toUpperCase();
const toLowerCase = (name) => name.toLowerCase();
const isEmptyString = (text) => text === void 0 || text === null || text === "";

function isEmpty(obj) {
  for (const _ in obj) {
    return false;
  }
  return true;
}
function emptyObject() {
  return {};
}
function emptyArray() {
  return [];
}
function checkProps(props) {
  if (props === void 0 || props === null) {
    throw new Error("Props is undefined or null");
  }
  Object.keys(props).forEach((key) => {
    if (props[key] === void 0 || props[key] === null) {
      throw new Error(`Property ${key} should not be undefined or null`);
    }
  });
}

export { SEP as S, emptyArray as a, addressToHex as b, checkProps as c, decodeHex as d, emptyObject as e, trimAll as f, toUpperCase as g, toLowerCase as h, isEmpty as i, isEmptyString as j, unwrapURI as k, lowerTrim as l, unwrapJSON as m, wrapToString as n, trim as t, upperTrim as u, wrapURI as w };
